import { BagPaymentTermListTableColumn } from '@/bag/bag-payment-term-list/bag-payment-term-list.model';
import { ChangeDetectionStrategy, Component, computed, input, LOCALE_ID } from '@angular/core';

@Component({
	selector: 'app-bag-payment-term-list-table-summary',
	templateUrl: './bag-payment-term-list-table-summary.component.html',
	styleUrls: ['./bag-payment-term-list-table-summary.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [{ provide: LOCALE_ID, useValue: 'pl-PL' }],
})
export class BagPaymentTermListTableSummaryComponent {
	readonly totalAmount = input(0);

	readonly tableColumns: BagPaymentTermListTableColumn[] = [{ id: 'amount', name: 'Suma kwoty' }];

	readonly tableKeys = this.tableColumns.map((column) => column.id);

	readonly data = computed(() => [{ amount: this.totalAmount() }]);
}
